<form [formGroup]="myForm" (ngSubmit)="onSubmit()" class="form">
    <p-progressBar mode="determinate" [style]="{height: '4px'}"
        [value]="currentStep / fomrJson?.length * 100"></p-progressBar>
    <!-- Logo del usuario (solo desktop) -->
    <div class="user-logo-container" *ngIf="userLogo && !is3DPreviewOpen && showLogo">
        <img [src]="userLogo" alt="Logo" class="user-logo">
    </div>

    <!-- Animated waves background -->
    <div class="waves-background">
        <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="geometricPrecision">
            <defs>
                <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                <linearGradient id="wave-gradient-1" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" [attr.stop-color]="primaryColor" stop-opacity="0.7" />
                    <stop offset="100%" [attr.stop-color]="secondaryColor" stop-opacity="0.7" />
                </linearGradient>
                <linearGradient id="wave-gradient-2" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" [attr.stop-color]="secondaryColor" stop-opacity="0.5" />
                    <stop offset="100%" [attr.stop-color]="primaryColor" stop-opacity="0.5" />
                </linearGradient>
            </defs>
            <g class="parallax">
                <use xlink:href="#gentle-wave" x="48" y="0" fill="url(#wave-gradient-1)" class="wave1" />
                <use xlink:href="#gentle-wave" x="48" y="3" fill="url(#wave-gradient-2)" class="wave2" />
            </g>
        </svg>
    </div>


    <div class="main-container">
        <div class="card-body h-100 w-100 d-flex flex-column">
            <div formArrayName="customForm">
                <ng-container *ngFor="let control of fomrJson; let i = index; let lastIndex = last">
                    <div style="width: 100%">
                        <div class="w-100" [ngClass]="{
                            'question-content': ['inputText','email', 'longText', 'dropdown'].includes(control.type),
                            'prescription-container': control.type === 'insolesPrescription',
                            'centered-question': control.type !== 'insolesPrescription'
                        }" *ngIf="currentStep === i " [formGroupName]="i">

                            <!-- label content -->
                            <div [ngStyle]="{'text-align': control.type === 'multipleChoice' || control.type === 'uniqueChoice' || control.type === 'customComponents' ? 'center' : 'start'}"
                                [class.header]="control.type === 'customComponents'"
                                [style.backgroundColor]="control.type === 'customComponents' ? primaryColor : null">
                                <label style="word-break: break-word; margin-bottom: 5px; font-size: 25px;"
                                    [ngClass]="{'fileLable': control.type === 'multipleChoice', 'component-label mb-0': control.type === 'customComponents' }"
                                    *ngIf="control.title !== '' && !control.required">{{
                                    control.title
                                    }}</label>
                                <label style="word-break: break-word; margin-bottom: 5px; font-size: 25px;"
                                    [ngClass]="{'fileLable': control.type === 'multipleChoice', 'component-label mb-0': control.type === 'customComponents' }"
                                    *ngIf="control.title !== '' && control.required === true">{{
                                    control.title?.length > 75
                                    ? (control.title | slice: 0 : 75) + '...'
                                    : control.title
                                    }}<sup class="required">*</sup></label>

                                <p style="word-break: break-word; margin-bottom: 15px; font-size: 16px; color: white; font-weight: normal;"
                                    *ngIf="control.subtitle && control.subtitle !== ''">
                                    {{control.subtitle}}
                                </p>

                                <!-- Question Image Preview -->
                                <div class="question-image-preview" *ngIf="control.image && control.image !== ''">
                                    <img [src]="control.image" alt="Question image" class="form-question-image">
                                </div>
                            </div>
                            <input *ngIf=" ['inputText','email'].includes(control.type)" class="form-control"
                                [type]="control.type === 'inputText' ? 'text' : control.type"
                                [formControlName]="control.type" />

                            <textarea *ngIf="control.type === 'longText'" class="form-control" rows="3"
                                [formControlName]="control.type"></textarea>

                            <!-- <ng-container *ngIf=" ['inputText','longText' ,'email','textarea'].includes(control.type)">
                            <div *ngIf="customFormControls.controls[i] instanceof FormGroup && customFormControls.controls[i].get(control.type)?.invalid && customFormControls.controls[i].get(control.type)?.touched"
                                class="required-error">
                                <div
                                    *ngIf="customFormControls.controls[i] instanceof FormGroup && customFormControls.controls[i].controls[control.type]?.errors?.['required']">
                                    Please enter {{control.type}}
                                </div>
                                <div class=""
                                    *ngIf="customFormControls.controls[i] instanceof FormGroup && customFormControls.controls[i].controls[control.type]?.errors?.['email']">
                                    Please enter valid {{control.type}}
                                </div>
                                <div
                                    *ngIf="customFormControls.controls[i] instanceof FormGroup && customFormControls.controls[i].get(control.type)?.errors?.['noWhiteSpaceValidator']">
                                    Please enter valid {{control.type}}
                                </div>
                            </div>
                        </ng-container> -->

                            <div *ngIf="errorMessage" class="error-message">
                                {{ errorMessage }}
                            </div>

                            <!-- multipleChoice -->
                            <ng-container *ngIf="control.type === 'multipleChoice'">
                                <div class="">
                                    <div class="row justify-content-center choice-que">
                                        <div class="col-md-4 mb-3 p-0"
                                            *ngFor="let item of control.choices; let opIndex=index">
                                            <div class="image-content">
                                                <div class="image"
                                                    [ngClass]="{'selected': item.options[0]?.isSelected === true || item.options[1]?.isSelected === true }">
                                                    <!--  (click)="onSelect(i,opIndex,control.name)" -->
                                                    <img (click)="onSelect(i,opIndex,control.type)"
                                                        style="width: 100%; height: 150px; border-radius: 10px 10px 0 0; object-fit: contain"
                                                        src="{{item.image}}" alt="">
                                                    <div class="contentBody">
                                                        <div style="padding-bottom: 8px;">
                                                            <span class="title">{{item.title}}</span>
                                                        </div>
                                                        <div>
                                                            <button class="me-2 button" type="button"
                                                                (click)="btnOnSelect(i,opIndex,ind,control.type)"
                                                                [ngStyle]="{'background': data.isSelected === true   ? '#4b9ddb' : '#fff', 'color' : data.isSelected === true ? '#fff' : ''}"
                                                                *ngFor="let data of item.options; let ind=index"><i
                                                                    *ngIf="data.isSelected === true ">&#x2713;
                                                                    &nbsp;</i>{{data.name}}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- uniqueChoice  -->
                            <ng-container *ngIf="control.type === 'uniqueChoice'">
                                <div class="">
                                    <div class="row justify-content-center choice-que">
                                        <div class="col-md-5 mb-3 p-0"
                                            *ngFor="let item of control.choices; let opIndex=index">
                                            <div class="image-content"
                                                (click)="onSingleSelect(i, opIndex, control.type)">
                                                <div class="image" [ngClass]="{'selected': item.isSelected === true }">
                                                    <img style="width: 100%; object-fit: contain; height: 200px; border-radius: 10px 10px 0 0;"
                                                        src="{{item.image}}" alt="">
                                                    <div class="contentBody">
                                                        <div>
                                                            <button *ngFor="let data of item.options, let ind=index"
                                                                (click)="onSingleSelect(i, opIndex, control.type, ind)"
                                                                class="me-2 button" type="button">{{data.name}}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>


                            <!-- dropdown -->
                            <ng-container *ngIf="control.type === 'dropdown'">
                                <ng-select [items]="control.options" formControlName="dropdown"
                                    placeholder="Select an option" [clearable]="true" [searchable]="true"
                                    bindLabel="name" bindValue="name" (blur)="markDropdownAsTouched(i)"
                                    (change)="onDropdownChange(i)">
                                </ng-select>
                                <div class="error-text" *ngIf="isDropdownInvalid(i)">
                                    Please select dropdown value
                                </div>
                            </ng-container>

                            <!-- requiredImages -->
                            <ng-container *ngIf="control.type === 'requiredImages'">
                                <div class="required-images-container">
                                    <div class="row justify-content-center">
                                        <div class="col-md-5 mb-4 margin-top-22 mw-200"
                                            *ngFor="let item of control.choices; let imgIndex = index">
                                            <div class="required-image-card">
                                                <!-- Imagen de ejemplo -->
                                                <div class="example-image-section">
                                                    <h5 class="image-title">{{item.title}}</h5>
                                                    <img [src]="item.image" [alt]="item.title" class="example-image">
                                                    <p class="example-label">Example</p>
                                                </div>

                                                <!-- Sección de subida de imagen del usuario -->
                                                <div class="user-upload-section">
                                                    <div class="upload-area"
                                                        [class.has-image]="getUserUploadedImage(i, imgIndex)"
                                                        [class.has-pdf]="isUploadedFilePDF(i, imgIndex)"
                                                        (click)="triggerFileInput(i, imgIndex)">

                                                        <!-- Cuando no hay archivo subido -->
                                                        <div *ngIf="!getUserUploadedImage(i, imgIndex)"
                                                            class="upload-placeholder">
                                                            <mat-icon>cloud_upload</mat-icon>
                                                            <p>Upload your file</p>
                                                            <small>Click to select image or PDF</small>
                                                        </div>

                                                        <!-- Cuando hay imagen subida -->
                                                        <div *ngIf="getUserUploadedImage(i, imgIndex) && !isUploadedFilePDF(i, imgIndex)"
                                                            class="uploaded-image-preview">
                                                            <img [src]="getUserUploadedImage(i, imgIndex)"
                                                                [alt]="item.title" class="user-image">
                                                            <div class="image-overlay">
                                                                <mat-icon>edit</mat-icon>
                                                                <p>Click to change</p>
                                                            </div>
                                                        </div>

                                                        <!-- Cuando hay PDF subido -->
                                                        <div *ngIf="isUploadedFilePDF(i, imgIndex)"
                                                            class="uploaded-pdf-preview">
                                                            <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
                                                            <p class="pdf-name">{{getUploadedFileName(i, imgIndex)}}</p>
                                                            <div class="image-overlay">
                                                                <mat-icon>edit</mat-icon>
                                                                <p>Click to change</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Input file oculto -->
                                                    <input type="file" [id]="'fileInput_' + i + '_' + imgIndex"
                                                        (change)="onImageUpload($event, i, imgIndex)"
                                                        accept="image/*,application/pdf" style="display: none;">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- insoles Prescription -->
                            <div [ngSwitch]="control.type">
                                <app-insoles-prescription *ngSwitchCase="'insolesPrescription'"
                                    [insolePrescription]="customFormControls.controls[i]" [clientId]="clientId"
                                    (threeDPreviewVisibleChange)="onThreeDPreviewVisibleChange($event)"></app-insoles-prescription>
                            </div>

                            <!-- custom component -->
                            <ng-container *ngIf="control.type === 'customComponents'">
                                <div class="row g-3" formArrayName="components"
                                    style="gap: 30px; justify-content: center;">

                                    <div *ngFor="let item of control.components; let j = index" [formGroupName]="j">
                                        <div class="card shadow-sm rounded-3">

                                            <div class="card-header py-2 text-center fw-bold"
                                                [style.backgroundColor]="primaryColor" [style.color]="'white'">
                                                <span class="custom-component-name">{{item.title}}</span>
                                            </div>

                                            <div class="card-body"
                                                [ngClass]="'component-body-' + (item.imagePosition || 'top')"
                                                [style.display]="'flex'"
                                                [style.flexDirection]="item.imagePosition === 'right' ? 'row-reverse' : item.imagePosition === 'left' ? 'row' : item.imagePosition === 'bottom' ? 'column-reverse' : 'column'"
                                                [style.align-items]="'center'" [style.justify-content]="'center'"
                                                [style.gap]="'20px'" [style.flexWrap]="'wrap'">

                                                <!-- Imagen -->
                                                <div *ngIf="item.image" class="text-center">
                                                    <img [src]="item.image"
                                                        [ngClass]="'image-' + (item.imageSize || 'medium')"
                                                        [style.max-height]="item.imageSize === 'small' ? '80px' : item.imageSize === 'large' ? '300px' : '195px'"
                                                        [style.max-width]="item.imageSize === 'small' ? '80px' : '100%'"
                                                        [style.padding]="item.imageSize === 'small' ? '10px' : '30px'">
                                                </div>

                                                <!-- Controls Container -->
                                                <div class="controls-container" [style.flex]="'1'"
                                                    [style.minWidth]="'auto'">
                                                    <!-- numberInputWithLabels -->
                                                    <div formArrayName="numberInputWithLabels">
                                                        <div *ngFor="let field of item.choices.numberInputWithLabels; let k = index"
                                                            class="mb-3">
                                                            <div class="input-group">
                                                                <span
                                                                    class="input-group-text">{{field.leftLabel}}</span>
                                                                <input type="number" class="form-control-small"
                                                                    [formControlName]="k" min="0">
                                                                <span
                                                                    class="input-group-text">{{field.rightLabel}}</span>
                                                            </div>
                                                            <small class="text-danger"
                                                                *ngIf="isNumberInputValid(i, j, k)">
                                                                Please enter valid value
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <!-- dropdownWithLabel -->
                                                    <div formArrayName="dropdownWithLabel" style="margin-top: 20px;">
                                                        <div *ngFor="let field of item.choices.dropdownWithLabel; let k = index"
                                                            class="mb-3 text-center">
                                                            <label class="form-label d-block">{{field.label}}</label>
                                                            <mat-form-field appearance="outline"
                                                                style="width: 200px; margin-top: 10px;">
                                                                <mat-select [formControlName]="k">
                                                                    <mat-option *ngFor="let option of field.options"
                                                                        [value]="option">
                                                                        {{ option }}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                            <small class="text-danger" *ngIf="isDropdownValid(i, j, k)">
                                                                Please select value
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <!-- checkboxWithLabel -->
                                                    <div formArrayName="checkboxWithLabel">
                                                        <div *ngFor="let field of item.choices.checkboxWithLabel; let k = index"
                                                            class="mb-3" style="margin-top: 15px;">
                                                            <label class="fw-bold">{{field.label}}</label>
                                                            <div class="row"
                                                                style="justify-content: center; gap: 20px; min-width: 300px"
                                                                [formArrayName]="k">
                                                                <div class="form-check"
                                                                    style="text-align: center; margin-top: 10px; display: flex; flex-direction: column; align-items: center;"
                                                                    *ngFor="let option of field.options; let l = index">
                                                                    <input class="form-check-input" type="checkbox"
                                                                        [formControlName]="l">
                                                                    <label class="form-check-label">{{option}}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- radioButtons -->
                                                    <div formArrayName="radioButtons">
                                                        <div *ngFor="let field of item.choices.radioButtons; let k = index"
                                                            style="display: flex; justify-content: center;">
                                                            <div class="row" style="width: 100%;">
                                                                <div class="col-6 form-check"
                                                                    *ngFor="let option of field.options; let l = index"
                                                                    style="display: flex; align-items: center; margin-bottom: 5px;">
                                                                    <input class="form-check-input" type="radio"
                                                                        [formControlName]="k.toString()"
                                                                        [value]="option">
                                                                    <label class="form-check-label">{{option}}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </ng-container>
                            <ng-container *ngIf="control.type === 'productsList'">
                                <div class="products-container">
                                    <ng-container *ngFor="let item of productsList; let j = index">
                                        <div class="product-card-horizontal">
                                            <div class="product-image">
                                                <img src="{{getProductImage(item)}}" alt="{{item.product.name}}">
                                            </div>
                                            <div class="product-info">
                                                <div class="product-details">
                                                    <h4 class="product-name">{{item.product.name}}</h4>
                                                    <h5 class="product-description">{{item.product.description}}</h5>
                                                    <div class="product-price-cart">
                                                        <p class="product-price">{{item?.price?.unit_amount / 100 |
                                                            currency: (item?.price?.currency | uppercase)}}</p>
                                                        <div class="cart-controls">
                                                            <p-button *ngIf="item.quantity === 0" label="Add to cart"
                                                                icon="pi pi-shopping-cart" styleClass="p-button-sm"
                                                                (click)="increment(j)">
                                                            </p-button>
                                                            <div *ngIf="item.quantity > 0" class="quantity-controls">
                                                                <p-button icon="pi pi-minus"
                                                                    styleClass="p-button-sm p-button-rounded"
                                                                    (click)="decrement(j)">
                                                                </p-button>
                                                                <span class="quantity">{{item.quantity}}</span>
                                                                <p-button icon="pi pi-plus"
                                                                    styleClass="p-button-sm p-button-rounded"
                                                                    (click)="increment(j)">
                                                                </p-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>

                        </div>

                        <div class="buttonSection" *ngIf="currentStep === i"
                            [ngClass]="{'floating-button' : control.type === 'insolesPrescription'}">

                            <!-- Checkout -->
                            <div class="checkout text-end my-3" *ngIf="lastIndex && isProductListInForm()">
                                <p-button label="Checkout" icon="pi pi-shopping-cart" styleClass="p-button-sm"
                                    [style]="{padding: '10px'}" [disabled]="!hasSelectedProducts()"
                                    (click)="checkout()"></p-button>
                            </div>

                            <!-- Último paso con Submit -->
                            <div class="continue-button d-flex gap-5 mt-2"
                                *ngIf="(lastIndex) && !isProductListInForm()">
                                <button mat-raised-button [style.backgroundColor]="primaryColor" [style.color]="'white'"
                                    *ngIf="currentStep === i && i !== 0"
                                    (click)="i === 0 ? backToCustomForm() : backForm(currentStep)">
                                    Back
                                </button>

                                <button mat-raised-button
                                    [style.backgroundColor]="isFormInvalidForStep(i) ? null : primaryColor"
                                    [style.color]="isFormInvalidForStep(i) ? null : 'white'" class="btn btn-block"
                                    type="submit" [disabled]="isFormInvalidForStep(i)">
                                    Submit
                                </button>
                            </div>

                            <!-- Pasos intermedios con Next -->
                            <div class="continue-button d-flex gap-5 mt-2" *ngIf="!(lastIndex)">
                                <button mat-raised-button [style.backgroundColor]="primaryColor" [style.color]="'white'"
                                    *ngIf="currentStep === i && i !== 0"
                                    (click)="i === 0 ? backToCustomForm() : backForm(currentStep)">
                                    Back
                                </button>

                                <button mat-raised-button
                                    [style.backgroundColor]="isFormInvalidForStep(i) ? null : primaryColor"
                                    [style.color]="isFormInvalidForStep(i) ? null : 'white'"
                                    (click)="nextForm(currentStep)" [disabled]="isFormInvalidForStep(i)">
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</form>

<p-dialog header="Cart" [(visible)]="isCheckoutModal" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false"
    [resizable]="false">
    <div class="card">
        <p-table [value]="productsList" [tableStyle]="{ 'width': '100%' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>Sr. No.</th>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
                <tr *ngIf="item.quantity > 0">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.product.name }}</td>
                    <td>{{ item?.price?.unit_amount / 100 | currency: (item?.price?.currency | uppercase) }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ (item.quantity * item?.price?.unit_amount) / 100 | currency: (item?.price?.currency |
                        uppercase) }}</td>
                </tr>
            </ng-template>
        </p-table>
        <h4 class="checkout-total">Total: <span class="text-danger">{{totalAmount / 100 | currency:
                (productsList[0]?.price?.currency | uppercase)}}</span></h4>
    </div>
    <ng-template pTemplate="footer">
        <form [formGroup]="emailForm">
            <input type="email" placeholder="Enter your email" formControlName="email" class="modern-input w-full" />

            <p-button label="Buy Now" styleClass="p-button-sm w-full" [style]="{padding: '10px'}" (click)="buyNow()"
                [loading]="loading" [disabled]="emailForm.get('email')?.invalid">
            </p-button>

            <small *ngIf="emailForm.get('email')?.invalid && emailForm.get('email')?.touched" style="color: red;">
                Please enter a valid email
            </small>
        </form>
    </ng-template>
</p-dialog>

<!-- <div class="container" *ngIf="isTableData">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Table Data</h5>
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th *ngFor="let item of tableData">{{item.key}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <ng-container *ngFor="let item of tableData, let i=index">
                                        <ng-container *ngIf="!item?.isArry && !item?.value?.image">
                                            <td>{{item.value}}</td>
                                        </ng-container>
                                        <ng-container *ngIf="item?.isArry">
                                            <td>
                                                <div class="d-flex">
                                                    <ng-container *ngFor="let data of item?.value;let lastIndex=last">
                                                        <ng-container *ngIf="data?.image">
                                                            <div>
                                                                <div>
                                                                    <img style="height: 50px; width: 50px; margin-right: 5px;"
                                                                        src="{{data.image}}" alt="">
                                                                </div>
                                                                <div class="">
                                                                    <ng-container>
                                                                        <span>{{data.legSide}}</span>
                                                                    </ng-container>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                        <span *ngIf="!data.image">{{data}}<i
                                                                *ngIf="!lastIndex">,</i>&nbsp;</span>
                                                    </ng-container>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container *ngIf="item?.value?.image">
                                            <td>
                                                <img style="height: 50px; width: 50px; margin-right: 5px;"
                                                    src="{{item.value.image}}" alt="">
                                                <div class="">
                                                    <span>{{item.value.title}}</span>
                                                </div>
                                            </td>
                                        </ng-container>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div> -->